module.exports = __webpack_public_path__ + "static/media/qatesting.24763a07.jpg";